import Vue from 'vue'
import VueRouter, { Route } from 'vue-router'
import MapLayout from '@/views/MapLayout.vue'
import Peligro from '@/views/Peligro.vue'
import Perfil from '@/views/Perfil.vue'
import PronosticoHidrico from '@/views/PronosticoHidrico.vue'
import PronosticoAire from '@/views/PronosticoAire.vue'
import PuntosPeligro from '@/views/PuntosPeligro.vue'
import PronosticoMeteorologico from '@/views/PronosticoMeteorologico.vue'
import PronosticoLocalMapas from '@/views/PronosticoLocalMapas.vue'
import ImagenesSatelitales from '@/views/ImagenesSatelitales.vue'
import Estaciones from '@/views/Estaciones.vue'
import Login from '@/views/Login.vue'
import UserEdit from '@/views/UserEdit.vue'
import DescargaPronostico from '@/views/DescargaPronostico.vue'
import MinutasPronostico from '@/views/MinutasPronostico.vue'
import store from '@/store'
import { getEnvironments } from '@/environments'

const env = getEnvironments()

Vue.use(VueRouter)

const getMapas = (mapas: string | (string | null)[]) => {
  if (typeof mapas === 'string') {
    return [Number(mapas)]
  }
  return mapas.map((el: string | null) => Number(el))
}

const routes = [
  {
    path: '/ingreso',
    name: 'login',
    component: Login
  },
  {
    path: '/opciones/editar-perfil',
    name: 'editar',
    component: UserEdit
  },
  {
    path: '/pronostico-historico',
    name: 'Pronóstico Histórico',
    component: DescargaPronostico
  },
  {
    path: '/minutas-pronostico',
    name: 'Minutas Pronóstico',
    component: MinutasPronostico
  },
  {
    path: '/',
    component: MapLayout,
    redirect: 'pronostico-aire',
    children: [
      {
        path: '/opciones',
        name: 'Opciones',
        component: Perfil
      },
      {
        path: '/peligro',
        name: 'peligro',
        props: (route: Route) => ({
          mapa: getMapas(route.query.mapa)
        }),
        component: Peligro
      },
      {
        path: '/puntos-peligro',
        name: 'Puntos Peligro',
        component: PuntosPeligro
      },
      {
        path: '/pronostico-hidrico',
        name: 'pronosticoHidrico',
        props: (route: Route) => ({
          region: route.query.region
        }),
        component: PronosticoHidrico
      },
      {
        path: '/pronostico-aire',
        name: 'pronosticoAire',
        component: PronosticoAire
      },
      {
        path: '/pronostico-meteorologico/:type?',
        name: 'pronosticoMeteorologico',
        query: {
          type: 'Precipitacion'
        },
        props: (route: Route) => ({
          type: route.query.type,
          vector: route.query.vector
        }),
        component: PronosticoMeteorologico
      },
      {
        path: '/pronostico-local/:type?',
        name: 'Pronostico Local',
        query: {
          type: 'Precipitacion'
        },
        props: (route: Route) => ({
          type: route.query.type,
          vector: route.query.vector
        }),
        component: PronosticoLocalMapas
      },
      {
        path: '/imagenes-satelitales/:type?',
        name: 'imagenesSatelitales',
        query: {
          type: 'Cobertura'
        },
        props: (route: Route) => ({
          type: route.query.type
        }),
        component: ImagenesSatelitales
      },
      {
        path: '/estaciones',
        name: 'estaciones',
        props: (route: Route) => ({
          grupotipovariable: route.query.grupotipovariable,
          tipovariable: route.query.tipovariable,
          estacion: route.query.estacion
        }),
        component: Estaciones
      }
    ]
  }
]

const router = new VueRouter({
  routes
})

const customNext = (to: Route, from: Route, next: any) => {
  if (from.fullPath !== to.fullPath) {
    next()
  }
}

if (env.auth) {
  router.beforeEach(async (to, from, next) => {
    await store.dispatch('account/getCredentials')
    if (store.getters['account/token'] !== '') {
      if (to.path === '/ingreso') {
        next('/pronostico-aire')
        return
      }
      customNext(to, from, next)
      return
    }
    if (to.path !== '/ingreso') {
      next('/ingreso')
      return
    }
    customNext(to, from, next)
  })
} else {
  router.beforeEach(async (to, from, next) => {
    if (to.path === '/ingreso') {
      next('/pronostico-aire')
      return
    }
    customNext(to, from, next)
  })
}

export default router
